module.exports = __webpack_public_path__ + "static/media/Style14.bb4e0bf4.PNG";